import brochure from "../../assets/icons/brochure.svg";
import indexCard from "../../assets/icons/indexCard.svg";
import form from "../../assets/icons/form.svg";
import { ResourceDownloadItem } from "./ResourceDownloadItem";
import aneuploidyRhLowRisk from "../../assets/files/BTO_Sample_Report_Aneuploidy_Rh.pdf";
import aneuploidyRhHighRisk from "../../assets/files/BTO_Sample_Report_High_Risk_T21.pdf";
import negativeCarrierReport from "../../assets/files/BTO_Sample_Report_Negative_Carrier.pdf";
import positiveLowRisk from "../../assets/files/BTO_Sample_Report_Positive_Carrier_Low_Risk.pdf";
import positiveHighRisk from "../../assets/files/BTO_Sample_Report_Positive_Carrier.pdf";
import twinHighRisk from "../../assets/files/BTO_Sample_Report_Twin_High_Risk.pdf";
import twinLowRisk from "../../assets/files/BTO_Sample_Report_Twin_Low_Risk.pdf";
import twinLowRiskRh from "../../assets/files/BTO_Sample_Report_Twin_Low_Risk_Rh.pdf";

export const SampleReportsData = (): JSX.Element[] => [
  <ResourceDownloadItem
    key="aneuploidy-sample"
    alt="Aneuploidy and RhD Report"
    icon={brochure}
    title="Aneuploidy and RhD Report"
    links={[
      {
        label: "Low Risk NIPT",
        link: aneuploidyRhLowRisk,
        linkInNewWindow: true,
        isDownload: true,
      },
      {
        label: "High Risk NIPT",
        link: aneuploidyRhHighRisk,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="negative-carrier"
    alt="negative-carrier"
    icon={indexCard}
    title="Negative Carrier Report"
    links={[
      {
        label: "Negative Carrier",
        link: negativeCarrierReport,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="positive-carrier"
    alt="Positive Carrier"
    icon={indexCard}
    title="Positive Carrier Report"
    links={[
      {
        label: "Low Risk Fetus",
        link: positiveLowRisk,
        linkInNewWindow: true,
        isDownload: true,
      },
      {
        label: "High Risk Fetus",
        link: positiveHighRisk,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="twin-high-risk"
    alt="Twin High Risk"
    icon={form}
    title="Twin Aneuploidy"
    links={[
      {
        label: "High Risk",
        link: twinHighRisk,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="twin-low-risk"
    alt="Twin Low Risk"
    icon={brochure}
    title="Twin Aneuploidy Low Risk"
    links={[
      {
        label: "Rh Negative",
        link: twinLowRiskRh,
        linkInNewWindow: true,
        isDownload: true,
      },
      {
        label: "Low Risk",
        link: twinLowRisk,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
];
